export default {
    url: '/questions',
    template: '<forms-forms-form-questions form-model="vm.formModel"></forms-forms-form-questions>',
    resolve: {
        formModel (FormResource, $stateParams) {
            return FormResource.get({ id: $stateParams.id, expand: 'formI18ns,category,author,tags,formQuestions,sites' }).$promise;
        }
    },
    controller (formModel) {
        this.formModel = formModel;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/forms/form/questions/index.js